import React from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import { Icon } from '../../../../../../../helpers/Icon';

function ThreeDStockBreadcrumbsChevron() {
  return (
    <span className="text-gray-500">
      <Icon icon={IconsEnum.CHEVRON_RIGHT} />
    </span>
  );
}

export default ThreeDStockBreadcrumbsChevron;
